import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  reconciliationGetCounterpartyParticipantsService,
  reconciliationSetStatusService
} from '../services/reconciliation.service';
import {
  EReconciliationStatus,
  IReconciliationGetParticipantsResponse,
  IReconciliationGetReconciliationsResponse,
  TReconciliationCounterpartyListReqParams,
  TReconciliationCounterpartyParticipantsListReqParams,
  TReconciliationParticipantsListReqParams,
} from '../types/reconciliation.types';

export const useGetReconParticipantsListQuery = (
  params: TReconciliationParticipantsListReqParams,
  options?: any,
): UseQueryResult<IReconciliationGetParticipantsResponse> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReconciliationQueryKeys].getParticipants(params),
    ...options,
  });

export const useGetCounterpartyParticipantsListQuery = (
  counterpartyGUID: string,
  params: TReconciliationCounterpartyParticipantsListReqParams,
  options?: any,
): UseQueryResult<IReconciliationGetParticipantsResponse> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReconciliationQueryKeys].getCounterpartyParticipants(counterpartyGUID, params),
    ...options,
  });

export const useGetCounterpartyReconsListQuery = (
  debtorGUID: string,
  creditorGUID: string,
  params: TReconciliationCounterpartyListReqParams,
  options?: any,
): UseQueryResult<IReconciliationGetReconciliationsResponse> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReconciliationQueryKeys].getCounterpartyList(creditorGUID, debtorGUID, params),
    ...options,
  });

export const useGetCounterpartyReconsDetailstQuery = (
  debtorGUID: string,
  creditorGUID: string,
  params: TReconciliationCounterpartyListReqParams,
  options?: any,
): UseQueryResult<IReconciliationGetReconciliationsResponse> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.ReconciliationQueryKeys].getCounterpartyDetails(creditorGUID, debtorGUID, params),
    ...options,
  });

export const useSetReconciliationStatusMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; reconGUID: string; status: EReconciliationStatus }) =>
      reconciliationSetStatusService(data.counterpartyGUID, data.reconGUID, data.status),
  });

export const useGetCounterpartyParticipantsListMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; params: TReconciliationCounterpartyParticipantsListReqParams}) =>
      reconciliationGetCounterpartyParticipantsService(data.counterpartyGUID, data.params),
  });
